export const FETCH_THEMATIC_AREA = 'FETCH_THEMATIC_AREA';
export const FETCH_THEMATIC_AREA_SUCCESS = 'FETCH_THEMATIC_AREA_SUCCESS';
export const FETCH_THEMATIC_AREA_FAILED = 'FETCH_THEMATIC_AREA_FAILED';
